/**
 * Client-seitiges Glob-Matching für den Testkäfig (Umbau A3).
 * Gleiche Semantik wie `src/dev-testbed/testlauf/glob.ts`.
 */

export {
  pfadInAllowlist,
  pfadPasstZuGlob,
} from "@/dev-testbed/testlauf/glob.ts";
